import React from "react";
import { useHistory } from "react-router";
import LDlogo from "../Assets/LDlogo.png";
import cs1 from "../Assets/cs1.jpg";
import cs2 from "../Assets/cs2.jpg";
import ig from "../Assets/ig.png";
import fb from "../Assets/fb.png";
import twit from "../Assets/twitter.png";
import LifeDocLogoWhite from "../Assets/LifeDlogoWhite.png";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    color: "white",
    backgroundColor: "#3b5998",
    padding: "30px",
    borderRadius: 0,
  },
  LD: {
    color: "#03ceac",
    fontSize: "25px",
  },
  peach: {
    backgroundColor: "#FC9483",
    padding: "30px",
  },
  pic2: {
    padding: "10px",
    width: "35px",
  },
  head: {
    color: "white",
    fontSize: "30px",
  },
  foot: {
    backgroundColor: "#03ceac",
    padding: "30px",
  },
  logo: {
    float: "right",
    color: "white",
    cursor: "pointer",
  },
  copyright: {
    float: "right",
    color: "white",
  },
  size: {
    fontSize: "17px",
  },
  button: {
    color: "white",
  },
}));

export default function About() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Container>
              <img src={LDlogo} alt="lifedoc" align="right" width="100px" />
              <h2>About LifeDoc</h2>
              <h5>LifeDoc/About LifeDoc</h5>
              <br />
            </Container>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Container>
            <br />
            <br />
            <br /> <br />
            <h1
              align="center"
              /* className={classes.LD} */ style={{
                fontSize: "40px",
                color: "#03ceac",
              }}
            >
              Who we are?
            </h1>
            <br />
            <div className={classes.size}>
              <p align="center">
                {" "}
                <span className={classes.LD}>
                  Cooperating with the Enhanced Community Quarantine (ECQ)
                </span>{" "}
                and staying at home is one way would help to flatten the curve,
              </p>
              <p align="center">
                medical information and anythng about COVID-19 are essential to
                make necessary transactions that can be done online.
              </p>
              <br />
              <p align="center">
                To help anyone with regards to their medical queries, we came up
                with LifeDoc, a{" "}
                <span className={classes.LD}>forum web application</span> that
                allows you
              </p>
              <p align="center">
                to ask or answer queries that would be helpful an essential for
                users relating to the COVID-19 crisis
              </p>
              <br />
              <p align="center">
                We are here to provide a{" "}
                <span className={classes.LD}>
                  platform for you to participate in the fight against COVID-19
                </span>{" "}
                using online
              </p>
              <p align="center">
                discussions, queries, and assessment of your personal risk
                status to the disease.
              </p>
              <br />
              <p align="center">
                Together, let's fight against COVID-19 crisis.
              </p>
            </div>
          </Container>
        </Grid>
        <Grid item xs={11}>
          <Container>
            <br />
            <br />
            <br />
            <br />
            <img src={cs2} alt="health" width="230px" align="right" />
            <br />
            <br />
            <h1 className={classes.LD}>Our Vision</h1>
            <p className={classes.size}>
              To see a world where affordable yet high quality
            </p>
            <p className={classes.size}>healthcare service is ordinary.</p>

            <br />
          </Container>
        </Grid>

        <Grid item xs={11}>
          <Container>
            <br />
            <br />
            <br />
            <img src={cs1} alt="health" width="330px" align="left" />
            <div align="right">
              <h1 className={classes.LD}>
                <br />
                <br />
                Our Mission
              </h1>
              <p className={classes.size}>
                To provide a superior and reliable platform that aims
              </p>
              <p className={classes.size}>
                to solve health concerns of the people.
              </p>
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
          </Container>
        </Grid>
        <Grid item xs={12} className={classes.peach}>
          <Container align="center">
            <div>
              <h1 className={classes.head}> Contact Us</h1>
              {/* Need to get in touch with LifeDoc Team? We're here to listen. */}
              <p className={classes.head}>
                {/*  While we provide you our service, we're also here to listen and
                answer questions that you might have. We look forward on hearing
                your concerns. */}
                While we provide you our service, we're also here to listen.
              </p>
              <div>
                <a
                  href="https://forms.gle/1xRPqVpGenh9Emwu5"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button
                    variant="outlined"
                    size="large"
                    className={classes.button}
                  >
                    {" "}
                    GET IN TOUCH
                  </Button>
                </a>

                <br />
                <br />
              </div>
            </div>
          </Container>
        </Grid>
        <Grid item xs={12} className={classes.foot}>
          <Container>
            <div>
              <a
                href="https://www.facebook.com/LifeDoc-106133824386093/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={fb} alt="fb" className={classes.pic2} />
              </a>
              <p className={classes.copyright}>
                Copyright &copy; {new Date().getFullYear()}. LifeDoc. All rights
                reserved.
              </p>
              <img
                src={LifeDocLogoWhite}
                alt="lifedoc"
                width="160px"
                className={classes.logo}
                onClick={() => history.push("/")}
              />
              <a
                href="https://twitter.com/lifedocph"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={twit} alt="twit" className={classes.pic2} />
              </a>
              <a
                href="https://www.instagram.com/lifedocph/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={ig} alt="ig " className={classes.pic2} />
              </a>
            </div>
          </Container>
        </Grid>
      </Grid>
    </div>
  );
}
